import { lazy } from 'react';
const ExitRequest = lazy(() => import('./ExitRequest'));

const ExitRequestRoutes = [
  {
    path: '/exitrequest',
    component: ExitRequest
  }
];

export default ExitRequestRoutes;
